module.exports = __webpack_public_path__ + "img/IMG20190716151835.a6dc75ee.jpg";